import bbox from "@turf/bbox";
import React from "react";
import { Layer, Source, useMap } from "react-map-gl/maplibre";

import { createComponent } from "@opendash/state";

import { PolygonType } from "../types";

interface Props {
  polygon: PolygonType;
  centerOnChange?: boolean;
}

export const MapPolygonLayer = createComponent<Props>(function MapPolygonLayer({
  polygon,
  centerOnChange,
}) {
  const { current: map } = useMap();

  const id = React.useMemo(() => JSON.stringify(polygon), [polygon]);

  const feature = React.useMemo(
    () => ({
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates: polygon,
      },
    }),
    [polygon]
  );

  React.useEffect(() => {
    if (map && centerOnChange) {
      const [minLng, minLat, maxLng, maxLat] = bbox(feature);

      map.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat],
        ],
        { padding: 40, duration: 100 }
      );
    }
  }, [feature]);

  return (
    <Source
      type="geojson"
      data={{
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",
          coordinates: polygon,
        },
      }}
    >
      <Layer
        id={`polygon-${id}`}
        type="line"
        layout={{
          "line-join": "round",
          "line-cap": "round",
        }}
        paint={{
          "line-color": window
            .getComputedStyle(document.documentElement)
            .getPropertyValue("--ant-primary-color"),
          "line-width": 5,
          "line-opacity": 0.6,
        }}
      />
    </Source>
  );
});
